import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { AuthService } from '../../../services/auth.service';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-inst-form',
  imports: [CommonModule, FormsModule],
  providers: [DatePipe],
  templateUrl: './inst-form.component.html',
  styleUrl: './inst-form.component.scss',
})
export class InstFormComponent {
  @Input() org_id: any;
  @Input() user: any;
  @Input() action: any;

  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');
  districts: any = null;

  base = 'institutes';		// important for API calls
  loading = false;
  headers: any = null;
  isReadonly = true;
  isEdit = false;
  // orgs: any = [];

  frmDataX: any = {};
  frmData: any = {
    id: null,
    inst_name: '',
    inst_type: '',
    website: 'http://',
    reg_no: '',
    gst_no: '',
    phone_no: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    country: 'India',
    logo: '',
    banner: '',
    reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
    // reg_date: this.datePipe.transform(this.currentDate, 'dd-MM-yyyy'), 
    is_active: true,
    org_id: 0
  };

  lFileName: string = 'No file chosen';
  lImgPreview: string | ArrayBuffer | null = null;
  lSelectedFile: File | null = null;

  bFileName: string = 'No file chosen';
  bImgPreview: string | ArrayBuffer | null = null;
  bSelectedFile: File | null = null;

  uploadProgress = 0;
  // isUploading = false;
  errorMessage = '';

  constructor(public dataService: DataService, private auth: AuthService, private http: HttpClient) {
    //
  }

  ngOnInit() {
    // console.log(this.user);
    // this.loading = true;
    // this.dataService.getAllRecords('organizations').then((res: any) => {
    //   this.orgs = res;
    //   this.loading = false;
    // });

    // Listen to changes continuously
    this.dataService.outerAction.subscribe((value: any) => {
      if (value) {
        if(value.component != 'institute') return;

        this.action = value.action;
        this.isEdit = value.action=='edit' ? true : false;

        if (value.data) {
          this.frmData = value.data;
          this.frmData.reg_date = this.frmData.reg_date.substr(0, 10);
          this.frmData.org_id = this.org_id;
          if(this.frmData.state) {
            this.districts = this.dataService.getDist(this.frmData.state);
          }
          if(this.frmData.logo) {
            this.lImgPreview = this.auth.svrUrl + '/uploads/' + this.user.erp_key + '/logo/' + this.frmData.logo;
          }
          if(this.frmData.banner) {
            this.bImgPreview = this.auth.svrUrl + '/uploads/' + this.user.erp_key + '/banner/' + this.frmData.banner;
          }
        } else {
          this.resetForm();
        }
        this.dataService.updateOuterAction(null);
      }
    });
  }

  ngOnChanges() {
    if (this.action) {
      switch (this.action) {
        case 'addnew':
          this.isEdit = false;
          this.isReadonly = false;
          this.frmDataSet();
          this.resetForm();
          break;
        case 'modify':
          this.isEdit = true;
          this.isReadonly = false;
          this.frmDataSet();
          break;
        case 'save':
          this.doSave();
          this.isReadonly = true;
          this.isEdit = false;
          break;
        case 'update':
          this.doUpdate();
          this.isReadonly = true;
          this.isEdit = false;
          break;
        case 'cancel':
          this.isReadonly = true;
          this.isEdit = false;
          this.resetForm();
          break;
        default:
          break;
      }

      this.action = '';
    }
  }

  frmDataSet() {
    if (this.frmData.org_name) {
      this.frmDataX = Object.assign({}, this.frmData);
    } else {
      this.frmDataX = {};
    }
  }

  resetForm() {
    this.frmData = {
      id: null,
      inst_name: '',
      inst_type: '',
      website: 'http://',
      reg_no: '',
      gst_no: '',
      phone_no: '',
      address: '',
      city: '',
      state: '',
      pincode: '',
      country: 'India',
      logo: '',
      banner: '',
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
      is_active: true,
      org_id: this.org_id || 0
    };
  }

  onLogoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.lSelectedFile = input.files[0];
      this.lFileName = this.lSelectedFile.name;

      // Read the file to create a local preview URL
      const reader = new FileReader();
      reader.onload = () => {
        this.lImgPreview = reader.result;
      };
      reader.readAsDataURL(this.lSelectedFile);
    } else {
      this.removeLogo();
    }
  }

  removeLogo(): void {
    let logoFile: any = document.getElementById('logo-file');
    if (logoFile) logoFile.value = null;
    this.frmData.logo = '';
    this.lImgPreview = null;
    this.lSelectedFile = null;
    this.lFileName = 'No file chosen';
    this.uploadProgress = 0;
    this.errorMessage = '';
  }

  onBnrSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.bSelectedFile = input.files[0];
      this.bFileName = this.bSelectedFile.name;

      // Read the file to create a local preview URL
      const reader = new FileReader();
      reader.onload = () => {
        this.bImgPreview = reader.result;
      };
      reader.readAsDataURL(this.bSelectedFile);
    } else {
      this.removeBnr();
    }
  }

  removeBnr(): void {
    let bnrFile: any = document.getElementById('bnr-file');
    if (bnrFile) bnrFile.value = null;
    this.frmData.banner = '';
    this.bImgPreview = null;
    this.bSelectedFile = null;
    this.bFileName = 'No file chosen';
    this.uploadProgress = 0;
    this.errorMessage = '';
  }

  doUpload(selectedFile: any, file4: string) {
    // this.isUploading = true;
    const formData4Img = new FormData();
    formData4Img.append('file', selectedFile);
    // formData4Img.append('erp_key', this.user.erp_key);

    this.http.post(this.auth.apiUrl+'/upload?file4='+file4+'&erp_key='+this.user.erp_key, formData4Img,
      {
        reportProgress: true,
        observe: 'events'
      }
    ).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(
            (100 * event.loaded) / (event.total || 1)
          );
        } else if (event.type === HttpEventType.Response) {
          // this.uploadResponse = event.body;
          // this.isUploading = false;
        }
      },
      error: (error: any) => {
        this.errorMessage = error.error?.message || 'Upload failed';
        // this.isUploading = false;
      }
    });
  }

  doSave() {
    if (this.lSelectedFile) {
      this.frmData.logo = this.lFileName;
      this.doUpload(this.lSelectedFile, 'logo');
    }
    if (this.bSelectedFile) {
      this.frmData.banner = this.bFileName;
      this.doUpload(this.bSelectedFile, 'banner');
    }

    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response: any) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.resetForm();
      },
      error: (error: any) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    if (this.lSelectedFile) {
      this.frmData.logo = this.lFileName;
      this.doUpload(this.lSelectedFile, 'logo');
    }
    if (this.bSelectedFile) {
      this.frmData.banner = this.bFileName;
      this.doUpload(this.bSelectedFile, 'banner');
    }

    this.loading = true;
    const myid = this.frmData.id;
    delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  ngOnDestroy() {
    this.removeLogo();
    this.removeBnr();
  }
}
